import React, { useEffect, useState } from "react";
import { useMediaQuery } from "./utils/hooks";
const MainContext = React.createContext();

function reducer(state, action) {
	switch (action.type) {
		case "UPDATE_MEDIA_QUERY": {
			return { ...state, ...action.payload };
		}
		default:
			return { ...state };
	}
}

function MainProvider({ children, initialValue }) {
	const isTablet = useMediaQuery("(max-width: 1023px) and (min-width: 768px)"),
		isUltraWide = useMediaQuery("(min-width: 1580px)"),
		isWide = useMediaQuery("(min-width: 1280px) and (max-width: 1579px)"),
		isMobile = useMediaQuery("(max-width: 767px)"),
		isMinor = useMediaQuery("(max-width: 425px)"),
		isDesktop = useMediaQuery("(max-width: 1279px) and (min-width: 1024px)"),
		[state, dispatch] = React.useReducer(reducer, {
			isMobile,
			isTablet,
			isDesktop,
			isWide,
			isMinor,
			isUltraWide,
			...initialValue,
		});
	useEffect(() => {
		dispatch({
			type: "UPDATE_MEDIA_QUERY",
			payload: { isTablet, isWide, isDesktop, isMobile, isUltraWide, isMinor },
		});
	}, [isTablet, isWide, isDesktop, isMobile, isUltraWide, isMinor]);

	const [openedMenu, setOpenedMenu] = useState(null);

	const value = { state, dispatch, openedMenu, setOpenedMenu };
	return <MainContext.Provider value={value}>{children}</MainContext.Provider>;
}

export { MainContext, MainProvider };
